import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { advertiserRulesAutoCompleteInput$, advertiserRulesAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const renderSuggestion = (suggestion) => (
   <div>
      {' '}
      {suggestion.name}
      {' '}
   </div>
);

const AdvertiserRulesAutoSuggest = renderAutoSuggestWithOptions(
   advertiserRulesAutoCompleteObservable$,
   advertiserRulesAutoCompleteInput$,
   renderSuggestion,
);

AdvertiserRulesAutoSuggest.defaultProps = {
   forceSelection: false,
   placeholder: 'Search Rules...',
};

export default AdvertiserRulesAutoSuggest;
